import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import _ from 'lodash';
import DelayTypeCard from '../../components/DelayTypeCard';
import ModalBannerConstants from '../../constants/ModalBannerConstants';
import AnnouncementWalkthroughSettings from '../../constants/AnnouncementWalkthroughSettings';
import dataModel from '../../models/DataModel';

import CrewIssuesIcon from '../../assets/images/delays/CrewIssues.svg';
import DamagedEquipmentIcon from '../../assets/images/delays/DamagedEquipment.svg';
import DependencyIcon from '../../assets/images/delays/Dependency.svg';
import MissingEquipmentIcon from '../../assets/images/delays/MissingEquipment.svg';
import NatureIcon from '../../assets/images/delays/Nature.svg';
import RoadIcon from '../../assets/images/delays/Road.svg';
import SiteAccessIcon from '../../assets/images/delays/SiteAccess.svg';
import WeatherIcon from '../../assets/images/delays/Weather.svg';
import OtherIcon from '../../assets/images/delays/Other.svg';

import './DelayTypesContainer.scss';

export class DelayTypesContainer extends Component {
  
  constructor(props) {
    super(props);
    DelayTypesContainer.propTypes = {
      selectDelayType: PropTypes.func,
    };

    this.getDelayTypesGrid = this.getDelayTypesGrid.bind(this);
  }

  componentDidMount() {

    if (this.props.currentUser && (!this.props.currentUser.settings || !this.props.currentUser.settings.user_has__viewed_mobile_delays_announcement_delay_type)) {
      const internalElement = <div className="announcement-highlight">
        <div className='delay-types-container'>
          {this.getDelayTypesGrid(true)}
        </div>
      </div>;

      let settings = _.cloneDeep(AnnouncementWalkthroughSettings.DelayTypePageAnnouncement);
      settings.highlightSettings.internalElement = internalElement;

      dataModel.showCircleGlobalModal(ModalBannerConstants.DELAYS_ANNOUNCEMENT_CIRCLE_ANNOUNCEMENT, {
        side: 'top-right-side', userSetting: 'user_has__viewed_mobile_delays_announcement_delay_type', announcementSettings: settings,
      });
    }
  }

  getDelayTypesGrid(readOnly) {
    return <div className='delay-types-container-inner'>
      <DelayTypeCard text={'Crew Issues'} delayType={'crew_issues'} iconSrc={CrewIssuesIcon} onSelect={!readOnly ? this.props.selectDelayType: null} />
      <DelayTypeCard text={'Damaged Equipment'} delayType={'damaged_equipment'} iconSrc={DamagedEquipmentIcon} onSelect={!readOnly ? this.props.selectDelayType: null} />
      <DelayTypeCard text={'Dependency'} delayType={'dependency'} iconSrc={DependencyIcon} onSelect={!readOnly ? this.props.selectDelayType: null} />
      <DelayTypeCard text={'Missing Equipment'} delayType={'missing_equipment'} iconSrc={MissingEquipmentIcon} onSelect={!readOnly ? this.props.selectDelayType: null} />
      <DelayTypeCard text={'Nature'} delayType={'nature'} iconSrc={NatureIcon} onSelect={!readOnly ? this.props.selectDelayType: null} />
      <DelayTypeCard text={'Road'} delayType={'road'} iconSrc={RoadIcon} onSelect={!readOnly ? this.props.selectDelayType: null} />
      <DelayTypeCard text={'Site Access'} delayType={'site_access'} iconSrc={SiteAccessIcon} onSelect={!readOnly ? this.props.selectDelayType: null} />
      <DelayTypeCard text={'Weather'} delayType={'weather'} iconSrc={WeatherIcon} onSelect={!readOnly ? this.props.selectDelayType: null} />
      <DelayTypeCard text={'Other'} delayType={'other'} iconSrc={OtherIcon} onSelect={!readOnly ? this.props.selectDelayType: null} />
    </div>;

  }

  render() {
    const routerState = this.props.history.getState();
    if (routerState && routerState.newDelay) {
      this.props.history.goBack({ newDelay: routerState.newDelay });
      return null;
    }
    const delayTypesGrid = this.getDelayTypesGrid(false);
    return (
      <div className='delay-types-container'>
      {delayTypesGrid}
      </div>
    );
  }
}

const mapStateToProps = (state, ownProps) => {
  return {
    currentUser: state.new_users.currentUser,
    actionCableUpdate: state.main.actionCableUpdate,
    isOnline: state.main.online,
    navigateUri: state.main.navigateUri,
  };
};
export default withRouter(connect(mapStateToProps)(DelayTypesContainer));



// WEBPACK FOOTER //
// ./src/containers/DelayTypesContainer/index.js